<template>
  <v-navigation-drawer
    v-model="mainMenuOpen"
    expand-on-hover
    permanent
    rail
    light
  >
    <!-- App Selection Dropdown -->
    <NavigationAppDropdown />
    <v-divider />
    <!-- Main Navigation Items -->
    <v-list-item
      v-for="item in appConfig.sitemap.menu"
      :key="item.title"
      :prepend-icon="item.icon"
      :title="item.title"
      :to="getRoutePath(item.title)"
      ripple
      class="text-overline"
    />
  </v-navigation-drawer>
</template>
<script setup lang="ts">
const appConfig = useAppConfig()
const navigationStore = useNavigationStore()
const { currentAppId, mainMenuOpen } = storeToRefs(navigationStore)

// Helper function to get the correct route path
const getRoutePath = (path: string) => {
  if (currentAppId.value && path !== "/") {
    return `/${currentAppId.value}/${path.toLowerCase()}`
  }
  return path
}
</script>
<style scoped></style>
